import { render } from "./PurchaseManagementlist.vue?vue&type=template&id=63f7750f&scoped=true"
import script from "./PurchaseManagementlist.vue?vue&type=script&lang=js"
export * from "./PurchaseManagementlist.vue?vue&type=script&lang=js"

import "./PurchaseManagementlist.vue?vue&type=style&index=0&id=63f7750f&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f7750f"]])

export default __exports__